import { type Location, type LocationDispatchProps, type SetLocationsProps } from 'src/types'

// consider adding props that last from game to game
const setLocations = ({ locations }: SetLocationsProps) => locations

export const reducer = (locations: Record<string, Location>, action: LocationDispatchProps) => {
  switch (action.type) {
    case 'SET_LOCATIONS':
      return setLocations(action)
    default:
      return locations
  }
}
